<template>
  <div class="dashboard__view review-kyc-documents">
    <div @click="$router.go(-1)" class="page__nav">
      <div class="page__nav__icon">
        <svg
          fill="none"
          height="16"
          viewBox="0 0 19 16"
          width="19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z"
            fill="#655D79"
          />
        </svg>
      </div>
      <div class="page__nav__text">Merchant KYC</div>
    </div>
    <div class="list">
      <div class="tab__content">
        <div style="padding: 20px">
          <!-- Account Information -->
          <div class="tab__content__top">
            <div class="tab__content__top__left">
              <div class="__title">Account Info</div>
              <span class="info"
                >Some basic information associated with this account
              </span>
            </div>
            <div class="tab__content__top__right">
              <div v-if="tabIndex === 1">
                <div class="static-input">
                  <span>Business name</span>
                  {{ merchantInfo.business_profile.business_registration_name }}
                </div>

                <div class="static-input">
                  <span>Full Name</span>
                  {{ merchantInfo.user_records.fullname }}
                </div>

                <div style="display: flex">
                  <div
                    class="static-input"
                    style="
                      width: 110px;
                      display: flex;
                      padding: 16px 10px;
                      margin-right: 20px;
                    "
                  >
                    <svg
                      width="27"
                      height="20"
                      viewBox="0 0 27 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <rect width="27" height="20" fill="url(#pattern0)" />
                      <defs>
                        <pattern
                          id="pattern0"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            xlink:href="#image0"
                            transform="translate(-0.134921) scale(0.0020749 0.00280112)"
                          />
                        </pattern>
                        <image
                          id="image0"
                          width="612"
                          height="357"
                          xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEBLAEsAAD/4QAoRXhpZgAASUkqAAgAAAABAJiCAgAGAAAAGgAAAAAAAABhbGV4c2z/4QTUaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/Pgo8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIj4KCTxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CgkJPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczpJcHRjNHhtcENvcmU9Imh0dHA6Ly9pcHRjLm9yZy9zdGQvSXB0YzR4bXBDb3JlLzEuMC94bWxucy8iICAgeG1sbnM6R2V0dHlJbWFnZXNHSUZUPSJodHRwOi8veG1wLmdldHR5aW1hZ2VzLmNvbS9naWZ0LzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGx1cz0iaHR0cDovL25zLnVzZXBsdXMub3JnL2xkZi94bXAvMS4wLyIgIHhtbG5zOmlwdGNFeHQ9Imh0dHA6Ly9pcHRjLm9yZy9zdGQvSXB0YzR4bXBFeHQvMjAwOC0wMi0yOS8iIHhtbG5zOnhtcFJpZ2h0cz0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3JpZ2h0cy8iIGRjOlJpZ2h0cz0iYWxleHNsIiBwaG90b3Nob3A6Q3JlZGl0PSJHZXR0eSBJbWFnZXMvaVN0b2NrcGhvdG8iIEdldHR5SW1hZ2VzR0lGVDpBc3NldElEPSI0NzE3OTMzOTciIHhtcFJpZ2h0czpXZWJTdGF0ZW1lbnQ9Imh0dHBzOi8vd3d3LmlzdG9ja3Bob3RvLmNvbS9sZWdhbC9saWNlbnNlLWFncmVlbWVudD91dG1fbWVkaXVtPW9yZ2FuaWMmYW1wO3V0bV9zb3VyY2U9Z29vZ2xlJmFtcDt1dG1fY2FtcGFpZ249aXB0Y3VybCIgPgo8ZGM6Y3JlYXRvcj48cmRmOlNlcT48cmRmOmxpPmFsZXhzbDwvcmRmOmxpPjwvcmRmOlNlcT48L2RjOmNyZWF0b3I+PHBsdXM6TGljZW5zb3I+PHJkZjpTZXE+PHJkZjpsaSByZGY6cGFyc2VUeXBlPSdSZXNvdXJjZSc+PHBsdXM6TGljZW5zb3JVUkw+aHR0cHM6Ly93d3cuaXN0b2NrcGhvdG8uY29tL3Bob3RvL2xpY2Vuc2UtZ200NzE3OTMzOTctP3V0bV9tZWRpdW09b3JnYW5pYyZhbXA7dXRtX3NvdXJjZT1nb29nbGUmYW1wO3V0bV9jYW1wYWlnbj1pcHRjdXJsPC9wbHVzOkxpY2Vuc29yVVJMPjwvcmRmOmxpPjwvcmRmOlNlcT48L3BsdXM6TGljZW5zb3I+CgkJPC9yZGY6RGVzY3JpcHRpb24+Cgk8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJ3Ij8+Cv/tAFBQaG90b3Nob3AgMy4wADhCSU0EBAAAAAAAMxwCUAAGYWxleHNsHAJ0AAZhbGV4c2wcAm4AGEdldHR5IEltYWdlcy9pU3RvY2twaG90bwD/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wgARCAFlAmQDAREAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAYCBQT/xAAYAQEAAwEAAAAAAAAAAAAAAAAAAgMEAf/aAAwDAQACEAMQAAAB81WEAAAAAAAAAAADuSuoJ6AAAAAAAAAAAAIGnBrvQAAAAAAAAAAAAAAAAAAAAAAAB3JXUE9AAAAAAAAAAAAEDTg13oAAAAAAAAAAAAAAAAAAAAAAAA7krqCegAAAAAAAAAAACBpwa70AAAAAAAAAAAAAAAAAAAAAAAAdyV1BPQAAAAAAAAAAABA04Nd6AAAAAAAAAAAAAAAAAAAAAAAAO5K6gnoAAAAAAAAAAAAgacGu9AAAAAAAAAAAAAAAAAAAAAAAAHcldQT0AAAAAAAAAAAAQNODXegAAAAAAAAAAAAAAAAAAAAAAADuSuoJ6AAAAAAAAAAAAIGnBrvQAAAAAAAAAAAAAAAAAAAAAAAB3JXUE9AAAAAAAAAAAAEDTg13oAAAAAAAAAAAAAAAAAAAAAAAA7krqCegAAAAAAAAAAACBpwa70AAAAAAAAAAAAAAAAAAAAAAAAdyV1BPQAAAAAAAAAAABA04Nd6AAAAAAAAAAAAAAAAAAAAAAAAO5K6gnoAAAAAAAAAAAAgacGu9AAAAAAAAAAAAAAAAAAAAAAAAHcldQT0AAAAAAAAAAAAQNODXegAAAAAAAAAAAAAAAAAAAAAAADuSuoJ6AAAAAAAAAAAAIGnBrvQAAAAAAAAAAAAAAAAAAAAAAAB3JXUE9AAAAAAAAAAAAEDTg13oAAAAAAAAAAAAAAAAAAAAAAAA7krqCegAAAAAAAAAAACBpwa70AAAAAAAAAAAAAAAAAAAAAAAAdyV1BPQAAAAAAAAAAABA04Nd6AAAAAAAAAAAAAAAAAAAAAAAAO5K6gnoAAAAAAAAAAAAgacGu9AAAAAAAAAAAAAAAAAAAAAAAAHcldQT0AAAAAAAAAAAAQNODXegAAAAAAAAAAAAAAAAAAAAAAADuSuoJ6AAAAAAAAAAAAIGnBrvQAAAAAAAAAAAAAAAAAAAAAAAB3JXUE9AAAAAAAAAAAAEDTg13oAAAAAAAAAAAAAAAAAAAAAAAA7krqCegAAAAAAAAAAACBpwa70AAAAAAAAAAAAAAAAAAAAAAAAdyV1BPQAAAAAAAAAAABA04Nd6AAAAAAAAAAAAAAAAAAAAAAAAO5K6gnoAAAAAAAAAAAAgacGu9AAAAAAAAAAAAAAAAAAAAAAAAHcldQT0AAAAAAAAAAAAQNODXegAAAAAAAAAAAAAAAAAAAAAAADuSuoJ6AAAAAAAAAAAAIGnBrvQAAAAAAAAAAAAAAAAAAAAAAAB3JXUE9AAAAAAAAAAAAEDTg13oAAAAAAAAAAAAAAAAAAAAAAAA7krqCegAAAAAAAAAAACBpwa70AAAAAAAAAAAAAAAAAAAAAAAAdyV1BPQAAAAAAAAAAABA04Nd6AAAAAAAAAAAAAAAAAAAAAAAAO5K6gnoAAAAAAAAAAAAgacGu9AAAAAAAAAAAAAAAAAAAAAAAAHcldQT0AAAAAAAAAAAAQNODXegAAAAAAAAAAAAAAAAAAAAAAADuSuoJ6AAAAAAAAAAAAIGnBrvQAAAAAAAAAAAAAAAAAAAAAAAB3JXUE9AAAAAAAAAAAAEDTg13oAAAAAAAAAAAAAAAAAAAAAAAA7krqCegAAAAAAAAAAACBpwa70AAAAAAAAAAAAAAAAAAAAAAAAdyV1BPQAAAAAAAAAAABA04Nd6AAAAAAAAAAAAAAAAAAAAAAAAO5K6gnoAAAAAAAAAAAAgacGu9AAAAAAAAAAAAAAAAAAAAAAAAHcldQT0AAAAAAAAAAAAQNODXegAAAAAAAAAAAAAAAAAAAAAAADuSuoJ6AAAAAAAAAAAAIGnBrvQAAAAAAAAAAAAAAAAAAAAAAAB3JXUE9AAAAAAAAAAAAEDTg13oAAAAAAAAAAAAAAAAAAAAAAAA7krqCegAAAAAAAAAAACBpwa70AAAAAAAAAAAAAAAAAAAAAAAAdyV1BPQAAAAAAAAAAABA04Nd6AAAAAAAAAAAAAAAAAAAAAAAAO5K6gnoAAAAAAAAAAAAgacGu9AAAAAAAAAAAAAAAAAAAAAAAAHcldQT0AAAAAAAAAAAAQNODXegAAAAAAAAAAAAAAAAAAAAAAADuSuoJ6AAAAAAAAAAAAIGnBrvQAAAAAAAAAAAAAAAAAAAAAAAB3JXUE9AAAAAAAAAAAAEDTg13oAAAAAAAAAAAGgAAAAAAAAAAADtyv707wAAAAAAAAAAAISrDoAAAAAAAAAAAA//8QAGxAAAQUBAQAAAAAAAAAAAAAAMQABBRFAUCH/2gAIAQEAAQUC0xh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw6UYdLDpRh0sOlGHSw00qVKlSpUqVKlSpUqVKlSpUqVKlSpUozx9LN5SpUqVKlSpUqVKlSpUqVKlSpUqVKlS//8QAGBEAAwEBAAAAAAAAAAAAAAAAA0FgQFD/2gAIAQMBAT8B0hcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxoXGhcaFxon1P/EABcRAQEBAQAAAAAAAAAAAAAAAAJgQFD/2gAIAQIBAT8B0mNMaY0xpjTGmNMaY0xpjTGmNMaY0xpjTGmNMaY0xpjTGmNMaY0xpjTGmNMaY0xpjTGmNMaY0xpjTGmNMaep/8QAGRAAAwEBAQAAAAAAAAAAAAAAA4HBYEBQ/9oACAEBAAY/AukquNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq40quNKrjSq+p//EAB8QAAIDAQEAAgMAAAAAAAAAAABxMUChUBEBIRBBgf/aAAgBAQABPyGzntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rrp57VGunntUa6ee1Rq044444444444444444444444458P4i9PT09PT09PT09PT09PT09PT09PT09PT38fX+/0OOOOOOOOOOOOOOOOOOOOOOOOOf/aAAwDAQACAAMAAAAQAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAAAAAAYAAAAAAAAAAAAJJJJJJJJJJJJKAAAAAAAAAAAAkJJJJJJJJJJJJP//EABwRAAAHAQEAAAAAAAAAAAAAAAABETFAgcFQIf/aAAgBAwEBPxCS6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsom6bqbKJum6myibpupsomlIECBAgQIECBAgQIECBAgQIECBAgQIH02UReBAgQIECBAgQIECBAgQIECBAgQIECBB//8QAGhEAAwEBAQEAAAAAAAAAAAAAABFBYAFAUP/aAAgBAgEBPxD01jaxtY2sbWNrG1jaxtY2sbWNrG1jaxtY2sbWNrG1jaxtY2sbWNrG1jaxtY2sbWNrG1jaxtY2sbWNrG1jaxtY2sbWNrG1ja+ohCEIQhCEIQhCEIQhCEIQivVzghCEIQhCEIQhCEIQhCEIQj//xAAdEAACAwACAwAAAAAAAAAAAAAAEWCh8AFAQVCB/9oACAEBAAE/EPZ5V0NyroblXQ3KuhuVdDcq6G5V0NyroblXQ3KuhuVdDcq6G5V0NyroblXQ3KuhuVdDcq6G5V0NyroblXQ3KuhuVdDcq6G5V0NyroblXQ3KuhuVdDcq6G5V0NyroblXQ3KuhuVdDcq6G5V0NyroblXQ3KuhuVdDcq6G5V0Nyru1pGkaRpGkaRpGkaRpGkaRpGkaRpGkaRpGkaRpGkaRpDS2+ygAAAOOT4p4NI0jSNI0jSNI0jSNI0jSNI0jSNI0jSNI0jSNI0jSNI//2Q=="
                        />
                      </defs>
                    </svg>
                    <div style="padding: 3px 10px">+234</div>
                  </div>
                  <div class="static-input">
                    <span>Phone Number</span>
                    {{ merchantInfo.user_records.mobile_number }}
                  </div>
                </div>
                <div class="static-input">
                  <span>Email Address</span>
                  {{ merchantInfo.user_records.email }}
                </div>
              </div>

              <div v-else class="toggle-icon">
                <loader class="p-0" v-if="isLoading"></loader>

                <div
                  @click="updateTagIndex(1)"
                  v-else-if="
                    !!merchantInfo.business_profile &&
                    !!merchantInfo.user_records
                  "
                  class="w-100 toggle-icon"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="15" cy="15" r="14.5" stroke="#7A153C" />
                    <path
                      d="M12 13.5L15 16.5L18 13.5"
                      stroke="#7A153C"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- Bank Details -->
          <div class="tab__content__top">
            <div class="tab__content__top__left">
              <div class="__title">Bank Details</div>
              <span class="info"
                >Here is the bank information associated with this account</span
              >
            </div>
            <div class="tab__content__top__right">
              <div v-if="tabIndex === 2">
                <div class="static-input">
                  <span>Bank </span>
                  {{ getBankName(merchantInfo.bank_code) }}
                </div>

                <div style="display: flex">
                  <div class="static-input" style="margin-right: 10px">
                    <span>Account Number</span>
                    {{ merchantInfo.business_nuban }}
                  </div>
                  <div class="static-input" style="margin-left: 10px">
                    <span>BVN</span>
                    {{ merchantInfo.business_bvn }}
                  </div>
                </div>
                <div class="static-input">
                  <span>Email Address</span>
                  {{ merchantInfo.email }}
                </div>
              </div>

              <div v-else class="toggle-icon">
                <loader class="p-0" v-if="isLoading"></loader>

                <div
                  @click="updateTagIndex(2)"
                  v-else-if="!!merchantInfo.business_nuban"
                  class="w-100 toggle-icon"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="15" cy="15" r="14.5" stroke="#7A153C" />
                    <path
                      d="M12 13.5L15 16.5L18 13.5"
                      stroke="#7A153C"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- Business Profile -->
          <div class="tab__content__top">
            <div class="tab__content__top__left">
              <div class="__title">Business Profile</div>
              <span class="info"
                >Some information about the business and how to contact the
                merhant.</span
              >
            </div>
            <div class="tab__content__top__right">
              <div v-if="tabIndex === 3">
                <br />
                <div class="__sub-title">About Business</div>
                <div>
                  <div class="static-input">
                    <span>Business Type </span>
                    {{
                      startCase(
                        merchantInfo.business_profile.business_registration_type
                      )
                    }}
                  </div>

                  <div class="static-input">
                    <span>Industry </span>
                    {{ startCase(merchantInfo.business_profile.industry) }}
                  </div>

                  <div class="static-input">
                    <span>Business Description</span>
                    {{
                      startCase(
                        merchantInfo.business_profile.business_description
                      )
                    }}
                  </div>

                  <div class="static-input">
                    <span>Tax Identification Number </span>
                    {{
                      startCase(
                        merchantInfo.business_profile.tax_identification_number
                      )
                    }}
                  </div>
                </div>
                <div class="__sub-title">Contact Information</div>

                <div>
                  <div class="static-input">
                    <span>Address</span>
                    {{ merchantInfo.business_profile.business_address }}
                  </div>

                  <div style="display: flex">
                    <div class="static-input" style="margin-right: 10px">
                      <span>State/City</span>
                      {{ merchantInfo.business_profile.city_state }}
                    </div>

                    <div
                      class="static-input"
                      style="
                        display: flex;
                        padding: 16px 10px;
                        margin-left: 10px;
                      "
                    >
                      <svg
                        width="27"
                        height="20"
                        viewBox="0 0 27 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <rect width="27" height="20" fill="url(#pattern0)" />
                        <defs>
                          <pattern
                            id="pattern0"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              xlink:href="#image0"
                              transform="translate(-0.134921) scale(0.0020749 0.00280112)"
                            />
                          </pattern>
                          <image
                            id="image0"
                            width="612"
                            height="357"
                            xlink:href="data:image/jpeg;base64,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"
                          />
                        </defs>
                      </svg>
                      <div style="padding: 3px 10px">Nigeria</div>
                    </div>
                  </div>
                  <div
                    class="static-input"
                    style="display: flex; justify-content: space-between"
                  >
                    <div>
                      <span>Uploaded Document </span>
                      {{
                        startCase(merchantInfo.proof_of_address.document_type)
                      }}
                    </div>
                    <div>
                      <div
                        class="link"
                        @click="
                          openDocument(merchantInfo.proof_of_address, true)
                        "
                      >
                        <span></span>
                        Download
                      </div>
                      <div
                        class="link"
                        @click="openDocument(merchantInfo.proof_of_address)"
                      >
                        <span></span>
                        View
                      </div>
                    </div>
                  </div>
                  <div class="static-input">
                    <span>Website</span>
                    {{ merchantInfo.business_profile.web_address }}
                  </div>
                  <div class="static-input">
                    <span>Dispute Email Address</span>
                    {{ merchantInfo.business_profile.dispute_email }}
                  </div>
                  <div class="static-input">
                    <span>Support Email Address</span>
                    {{ merchantInfo.business_profile.support_email }}
                  </div>
                  <div class="static-input">
                    <span>Support number</span>
                    {{ merchantInfo.business_profile.support_number }}
                  </div>
                  <div
                    class="static-input"
                    style="display: flex; justify-content: space-between"
                    v-for="(
                      doc, index
                    ) in merchantInfo.merchant_documents.filter(
                      (doc) => doc.document_type === 'merchant_proof_of_address'
                    )"
                    :key="index"
                  >
                    <div>
                      <span>Uploaded Document </span>
                      {{ startCase(doc.document_type) }}
                    </div>
                    <div class="link" @click="openDocument(doc)">
                      <span></span>
                      View
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="toggle-icon">
                <loader class="p-0" v-if="isLoading"></loader>

                <div
                  @click="updateTagIndex(3)"
                  v-else-if="
                    !!merchantInfo.business_profile &&
                    !!merchantInfo.merchant_documents
                  "
                  class="w-100 toggle-icon"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="15" cy="15" r="14.5" stroke="#7A153C" />
                    <path
                      d="M12 13.5L15 16.5L18 13.5"
                      stroke="#7A153C"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- KYC Details -->
          <div class="tab__content__top">
            <div class="tab__content__top__left">
              <div class="__title">KYC Details</div>
              <span class="info"
                >Review regulatory documents about business.</span
              >
            </div>
            <div class="tab__content__top__right">
              <div v-if="tabIndex === 4">
                <br />
                <div
                  class="__sub-title text-right"
                  v-if="
                    merchantInfo.merchant_documents.filter(
                      (doc) =>
                        doc.document_type !== 'merchant_proof_of_address' ||
                        doc.document_type !== 'proof_of_address'
                    ).length <= 0
                  "
                >
                  No document uploaded
                </div>
                <div>
                  <div
                    class="static-input"
                    style="display: flex; justify-content: space-between"
                    v-for="(
                      doc, index
                    ) in merchantInfo.merchant_documents.filter(
                      (doc) => doc.document_type !== 'merchant_proof_of_address'
                    )"
                    :key="index"
                  >
                    <div>
                      <span>Uploaded Document </span>
                      {{ startCase(doc.document_type) }}
                    </div>
                    <div class="link" @click="openDocument(doc)">
                      <span></span>
                      View
                    </div>
                  </div>
                </div>

                <div
                  v-for="(personnel, index) in merchantInfo.personnel"
                  :key="index"
                >
                  <div class="__sub-title">
                    ({{ index + 1 }}) Director Details
                  </div>
                  <div style="display: flex; margin: 0">
                    <div class="static-input" style="margin-right: 10px">
                      <span>First Name</span>
                      {{ personnel.firstname }}
                    </div>
                    <div class="static-input" style="margin-left: 10px">
                      <span>Last Name</span>
                      {{ personnel.lastname }}
                    </div>
                  </div>

                  <div style="display: flex; margin: -20px 0">
                    <div
                      class="static-input"
                      style="
                        width: 110px;
                        display: flex;
                        padding: 16px 10px;
                        margin-right: 20px;
                      "
                    >
                      <svg
                        width="27"
                        height="20"
                        viewBox="0 0 27 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <rect width="27" height="20" fill="url(#pattern0)" />
                        <defs>
                          <pattern
                            id="pattern0"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              xlink:href="#image0"
                              transform="translate(-0.134921) scale(0.0020749 0.00280112)"
                            />
                          </pattern>
                          <image
                            id="image0"
                            width="612"
                            height="357"
                            xlink:href="data:image/jpeg;base64,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"
                          />
                        </defs>
                      </svg>
                      <div style="padding: 3px 10px">+234</div>
                    </div>
                    <div class="static-input">
                      <span>Phone Number</span>
                      {{ personnel.phone_number }}
                    </div>
                  </div>

                  <div class="static-input">
                    <span>Date of Birth </span>
                    {{ dateOfBirth(personnel.date_of_birth) }}
                  </div>

                  <div
                    class="static-input"
                    style="display: flex; justify-content: space-between"
                    v-for="(doc, index) in personnel.document"
                    :key="index"
                  >
                    <div>
                      <span>Document Type </span>
                      {{ startCase(doc.document_type) }}
                    </div>
                    <div class="link" @click="openDocument(doc)">
                      <span></span>
                      View
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="toggle-icon">
                <loader class="p-0" v-if="isLoading"></loader>

                <div
                  @click="updateTagIndex(4)"
                  v-else-if="!!merchantInfo.merchant_documents"
                  class="w-100 toggle-icon"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="15" cy="15" r="14.5" stroke="#7A153C" />
                    <path
                      d="M12 13.5L15 16.5L18 13.5"
                      stroke="#7A153C"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div style="min-width: 20px; padding: 20px; height: 50px"></div>

          <div class="nav">
            <ButtonV2
              buttonName="Request documents"
              classes="woven-border-only"
              buttonType="button"
              :onClick="() => toggleModal(null)"
            />

            <div style="min-width: 10px; padding: 10px; height: 20px"></div>

            <ButtonV2
              v-if="
                this.merchantInfo.status.toLowerCase() === 'pending_kyc_review'
              "
              buttonName="Approve"
              classes="woven-color"
              buttonType="button"
              :onClick="() => (approveMerchantModal = true)"
            />
          </div>

          <div style="min-width: 20px; padding: 20px; height: 50px"></div>

          <div style="min-width: 20px; padding: 20px; height: 50px"></div>
        </div>
      </div>
    </div>

    <kyc-notification
      v-if="approveMerchantModal"
      approve
      :on-close="() => (approveMerchantModal = false)"
      :on-continue="approve"
    />

    <div v-if="iframeSrc">
      <Modal classes="request-change large" :styleClass="styleClass">
        <template v-slot:trigger>
          <div
            style="
              height: 100vh;
              width: 100vw;
              background: none;
              position: fixed;
              top: 0;
              left: 0;
              bottom: 0;
              cursor: pointer;
            "
            @click="() => toggleModal(true)"
          />
        </template>
        <template v-slot:content>
          <div
            style="
              position: absolute;
              top: -3%;
              right: 0;
              color: #fff;
              cursor: pointer;
            "
            @click="() => toggleModal(true)"
          >
            Close x
          </div>
          <div class="request-change-modal">
            <iframe
              style="width: 100%; height: 100vh; position: relative"
              v-if="iframeSrc"
              :src="iframeSrc"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </template>
      </Modal>
    </div>
    <div v-if="showModal">
      <Modal classes="request-change" :styleClass="styleClass">
        <template v-slot:content>
          <div
            style="
              position: absolute;
              top: -8%;
              right: 0;
              color: #fff;
              cursor: pointer;
            "
            @click="toggleModal"
          >
            Close x
          </div>
          <div class="request-change-modal">
            <div class="request-change__content">
              <svg
                width="47"
                height="60"
                viewBox="0 0 47 60"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M39.1908 0H2.3407C1.05012 0 0 1.05 0 2.3407V46.817C0 48.1077 1.05 49.1577 2.3407 49.1577H4.7093C4.87172 49.1577 5.02676 49.0903 5.13762 48.9716L41.4072 10.1261C41.5084 10.0175 41.5648 9.87457 41.5648 9.72621V2.37398C41.5649 1.065 40.4999 0 39.1908 0V0Z"
                  fill="#FF6986"
                />
                <path
                  d="M46.3105 14.4715V50.918C46.3105 52.2094 45.2605 53.2594 43.9703 53.2594H6.46445C5.17305 53.2594 4.12305 52.2094 4.12305 50.918V6.73477C4.12305 5.44453 5.17305 4.39453 6.46445 4.39453H36.2324L37.3152 5.47734L46.3105 14.4715Z"
                  fill="#FFDADB"
                />
                <path
                  d="M46.3105 14.4712V50.9177C46.3105 52.2091 45.2605 53.2591 43.9703 53.2591H6.46445C5.17305 53.2591 4.12305 52.2091 4.12305 50.9177V50.3294H41.541C42.8477 50.3294 43.907 49.27 43.907 47.9622V14.4712L37.3152 5.47705L46.3105 14.4712Z"
                  fill="#B4D2D7"
                />
                <path
                  d="M46.3105 14.4715H43.907L37.0035 14.4703C36.5781 14.4703 36.2324 14.1258 36.2324 13.6992V4.39453C36.3883 4.39453 36.5371 4.45547 36.6473 4.56562L46.1395 14.0578C46.2496 14.168 46.3105 14.3168 46.3105 14.4715Z"
                  fill="white"
                />
                <path
                  d="M46.3107 14.4713H43.9072L36.6475 4.56543L46.1396 14.0576C46.2498 14.1678 46.3107 14.3166 46.3107 14.4713Z"
                  fill="white"
                />
                <path
                  d="M14.7256 22.3188H35.7516C36.237 22.3188 36.6305 21.9254 36.6305 21.4399C36.6305 20.9544 36.237 20.561 35.7516 20.561H14.7256C14.2402 20.561 13.8467 20.9544 13.8467 21.4399C13.8467 21.9254 14.2402 22.3188 14.7256 22.3188Z"
                  fill="white"
                />
                <path
                  d="M35.7516 25.7446H14.7256C14.2402 25.7446 13.8467 26.138 13.8467 26.6235C13.8467 27.109 14.2402 27.5024 14.7256 27.5024H35.7516C36.237 27.5024 36.6305 27.109 36.6305 26.6235C36.6305 26.138 36.237 25.7446 35.7516 25.7446Z"
                  fill="white"
                />
                <path
                  d="M35.7516 31.0312H31.5977C31.1123 31.0312 30.7188 31.4246 30.7188 31.9102C30.7188 32.3957 31.1123 32.7891 31.5977 32.7891H35.7516C36.237 32.7891 36.6305 32.3957 36.6305 31.9102C36.6305 31.4246 36.237 31.0312 35.7516 31.0312Z"
                  fill="white"
                />
                <path
                  d="M27.4613 31.0312H14.7256C14.2402 31.0312 13.8467 31.4246 13.8467 31.9102C13.8467 32.3957 14.2402 32.7891 14.7256 32.7891H27.4613C27.9467 32.7891 28.3402 32.3957 28.3402 31.9102C28.3402 31.4246 27.9467 31.0312 27.4613 31.0312Z"
                  fill="white"
                />
                <path
                  d="M36.2783 48.9624C36.2783 55.0479 31.326 60.0003 25.2393 60.0003C24.7635 60.0003 24.2947 59.9698 23.8354 59.9112H23.8307C18.4061 59.2163 14.2002 54.571 14.2002 48.9624C14.2002 43.3526 18.4061 38.7073 23.8307 38.0124H23.8354C24.2947 37.9538 24.7635 37.9233 25.2393 37.9233C31.326 37.9233 36.2783 42.8757 36.2783 48.9624Z"
                  fill="#FF6986"
                />
                <path
                  d="M36.2779 48.9624C36.2779 55.0479 31.3256 60.0003 25.2389 60.0003C24.7631 60.0003 24.2943 59.9698 23.835 59.9112C29.2596 59.2163 33.4654 54.571 33.4654 48.9624C33.4654 43.3526 29.2596 38.7073 23.835 38.0124C24.2943 37.9538 24.7631 37.9233 25.2389 37.9233C31.3256 37.9233 36.2779 42.8757 36.2779 48.9624Z"
                  fill="#EA3487"
                />
                <path
                  d="M29.7037 48.117C29.3605 48.4603 28.804 48.4602 28.4608 48.1171L26.1178 45.7741V54.2709C26.1178 54.7564 25.7243 55.1498 25.2389 55.1498C24.7535 55.1498 24.36 54.7564 24.36 54.2709V45.7741L22.0169 48.1171C21.6737 48.4602 21.1172 48.4603 20.774 48.117C20.4308 47.7737 20.4308 47.2172 20.774 46.8741L24.6174 43.0308C24.789 42.8592 25.014 42.7734 25.2389 42.7734C25.4638 42.7734 25.6888 42.8592 25.8603 43.0308L29.7037 46.8741C30.047 47.2172 30.047 47.7737 29.7037 48.117Z"
                  fill="white"
                />
              </svg>

              <div class="request-change__title">Request Documents</div>

              <div style="padding: 10px; margin: 0px; height: 10px" />
              <div class="request-change__describe">
                Kindly select the documents you would like to request from your
                merchant or leave a feedback.
              </div>
              <div style="padding: 10px; margin: 0px; height: 10px" />

              <Dropdown
                label="Select Document"
                :options="options"
                :onOptionSelected="({ id }) => addDocumentType(id)"
              />
              <ul class="selected__documents">
                <li v-for="(documentType, index) in documentTypes" :key="index">
                  <svg
                    data-v-cd437612=""
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="cr__pointer"
                    @click="removeDocumentType(index)"
                    title="Remove Selection"
                  >
                    <path
                      data-v-cd437612=""
                      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
                      stroke="#C61010"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      data-v-cd437612=""
                      d="M4 5L15 16"
                      stroke="#C61010"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  &nbsp;&nbsp;{{
                    options.find((option) => option.id === documentType).value
                  }}
                </li>
              </ul>
              <div style="padding: 10px; margin: 0px; height: 10px" />
              <div style="text-align: left">
                <Textarea
                  label="Add a note"
                  :handle-text-area="(val) => (addNote = val)"
                  :value="addNote"
                />
              </div>
              <ButtonV2
                buttonName="Submit Request"
                classes="woven-color height"
                buttonType="submit"
                :on-click="requestChange"
              />
            </div>
            <WovenStrip :loading="isLoading" />
          </div>
        </template>
      </Modal>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import InputV2 from "../../../components/inputv2";
import ButtonV2 from "../../../components/buttonV2";
import Modal from "../../../components/modal";
import WovenStrip from "../../../components/wovenstrip";
import Textarea from "../../../components/textarea";
import Dropdown from "@/components/dropdown";
import qs from "querystring";
import lodash from "lodash";
import Vue from "vue";
import startCase from "lodash/startCase";
import Button from "@/components/button";
import KycNotification from "./kyc-notification";
import Loader from "../../../components/loader";

export default {
  metaInfo: {
    title: "Merchants KYC Details",
  },

  components: {
    Loader,
    KycNotification,
    Button,
    Dropdown,
    Datepicker,
    InputV2,
    ButtonV2,
    Modal,
    WovenStrip,
    Textarea,
  },
  data() {
    return {
      iframeSrc: null,
      isLoading: false,
      tabIndex: 0,
      showModal: false,
      styleClass: "display: none",
      merchantInfo: {
        proof_of_address: {},
        business_profile: {},
        user_records: {},
      },
      needs: {
        industry: "",
      },
      documentTypes: [],
      addNote: "",
      options: [
        {
          id: "international_passport",
          value: "International Passport",
        },
        {
          id: "proof_of_address",
          value: "Proof of Address",
        },
        {
          id: "driver_license",
          value: "Driver License",
        },
        {
          id: "business_name_certificate",
          value: "Business Name Certificate",
        },
        {
          id: "authorization_letter",
          value: "Authorization Letter",
        },
        {
          id: "official_gazette",
          value: "Official Gazette",
        },
        {
          id: "government_approval",
          value: "Government Approval",
        },
        {
          id: "business_owner_document",
          value: "Business Owner Document",
        },
        {
          id: "cac_form",
          value: "CAC FORM",
        },
        {
          id: "memorandum",
          value: "Memorandum",
        },
        {
          id: "cooperative_certificate",
          value: "Cooperative Certificate",
        },
        {
          id: "certified_application_form",
          value: "Certified Application Form",
        },
        {
          id: "certificate_of_incorporation",
          value: "Certified Incorporation",
        },
      ],
      approveMerchantModal: false,
    };
  },

  created() {
    this.fetchMerchants();
  },
  watch: {
    // call again the fetch method if the route changes; this is necessary especially because of users
    // using the search and might be on this route already.
    $route: "fetchMerchants",
  },

  methods: {
    addDocumentType(id) {
      if (!this.documentTypes.includes(id)) {
        this.documentTypes.push(id);
      }
    },
    removeDocumentType(index) {
      this.documentTypes.splice(index, 1);
    },
    toggleModal(iframe = false) {
      if (!iframe) {
        this.showModal = !this.showModal;
      } else {
        this.iframeSrc = null;
        this.showModal = null;
      }
      this.styleClass =
        this.styleClass === "display: block"
          ? "display: none !important"
          : "display: block";
    },
    startCase: startCase,
    updateTagIndex(tabIndex) {
      this.tabIndex = tabIndex;
    },
    dateOfBirth(date) {
      return window.moment(date || new Date()).format("ll");
    },

    requestChange() {
      this.isLoading = !this.isLoading;
      let doc_id_array = this.merchantInfo.merchant_documents
        .filter((doc) =>
          this.documentTypes.includes(
            doc.document_type.toString().toLowerCase()
          )
        )
        .map(({ id, document_type }) => ({
          doc_id: id,
          document_type: document_type,
        }));

      this.merchantInfo.personnel.forEach((director) => {
        doc_id_array = [
          ...doc_id_array,
          ...director.document
            .filter((doc) =>
              this.documentTypes.includes(
                doc.document_type.toString().toLowerCase()
              )
            )
            .map(({ id, document_type }) => ({
              doc_id: id,
              document_type: document_type,
            })),
        ];
      });

      let unsubmitted_documents = [];

      lodash.forEach(this.documentTypes, function (document_type) {
        if (
          lodash.filter(doc_id_array, ["document_type", document_type])
            .length <= 0
        ) {
          unsubmitted_documents.push({
            doc_id: null,
            document_type: document_type,
          });
        }
      });

      let doc_array = [...doc_id_array, ...unsubmitted_documents];

      this.$http
        .post(`dashboard/admin/kyc_kickback/${this.$route.params.id}`, {
          note: this.addNote,
          doc_array,
        })
        .then((response) => {
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Successfull",
            text: response.body.message,
          });
          this.toggleModal();
          this.isLoading = !this.isLoading;
          this.$router.push({ path: "/dashboard/merchants?page=1" });
        })
        .catch((error) => {
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message || error.message || error.statusText,
          });
          this.isLoading = !this.isLoading;
        });
    },

    fetchMerchants() {
      this.isLoading = true;
      this.$http
        .get(
          `admin/merchants/pending_kyc_review?merchant_id=${this.$route.params.id}`
        )
        .then((response) => {
          const {
            business_profile,
            rows,
            proof_of_address,
          } = response.body.data;

          if (rows.length > 0 && rows[0].user_records) {
            const user_records = rows[0].user_records[0] || {};
            this.merchantInfo = {
              ...rows[0],
              business_profile: business_profile || {},
              proof_of_address: proof_of_address || {},
              user_records,
            };
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
        });
    },
    approve() {
      this.$http
        .post(`admin/merchants/approve?merchant_id=${this.$route.params.id}`, {
          merchant_id: this.$route.params.id,
        })
        .then((response) => {
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: response.body.message,
          });
          this.approveMerchantModal = false;
        })
        .catch((error) => {
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
        });
    },
    getBankName(code) {
      const list = this.$store.getters.getBankList.filter(
        (bank) => bank.code == code
      );
      if (list[0]) return list[0].bank;
      return "";
    },
    openDocument(doc, download = false) {
      const st = qs.encode({
        requestId: Date.now() + doc.id.toString(),
        token: this.$store.state.userDetails.token,
        type: download ? "download" : "open",
      });
      const url = `${process.env.VUE_APP_API_URL}/dashboard/admin/document/${doc.id}?${st}`;
      // window.open (url)
      if (download) {
        this.$notify({
          group: "notifications-default",
          type: "success",
          title: "Success",
          text: "Your download is in progress.",
          duration: 10000,
        });
        window.location.href = url;
      } else {
        this.toggleModal(true);
        this.iframeSrc = url;
      }
    },
  },
};
</script>

<style lang="scss">
.w-100 {
  width: 100%;
}

.text-right {
  text-align: right;
}

.selected__documents {
  display: flex;
  flex-direction: column;
  align-items: baseline;

  li {
    margin-bottom: 0.5em;
    display: flex;
    align-items: center;
  }

  .cr__pointer {
    cursor: pointer;
  }
}

.review-kyc-documents {
  .list {
    border: none !important;
  }
  .request-change-modal {
    padding: 30px;
    overflow: auto;
  }
  .__title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 27px;
    color: #7a153c;
  }
  .info {
    display: block;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #616e7c;
    margin-top: 12px;
  }
  .tab__content__top {
    border-bottom: 1px solid rgba(223, 227, 232, 0.6);
    align-items: flex-start;
  }
  .tab__content__top__left {
    padding: 20px 0;
  }

  .tab__content__top__right {
    width: 50%;
    display: flex;
    flex-direction: column;
  }
  .static-input {
    width: 100%;
    padding: 10px 16px 16px 16px;
    margin: 20px 0;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: rgba(60, 63, 67, 0.6);
    outline: none;
    background: rgba(196, 196, 196, 0.1);
    border: 0.5px solid rgba(97, 110, 124, 0.25);
    box-sizing: border-box;
    border-radius: 4px;

    span {
      display: block;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 13px;
      color: rgba(97, 110, 124, 0.6);
      padding-bottom: 5px;
    }
    .link {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #e00b5b;
      cursor: pointer;
    }
  }
  .toggle-icon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    min-height: 100px;
  }
  .__sub-title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    /* identical to box height */

    color: rgba(18, 18, 18, 0.85);
  }

  .nav {
    display: flex;
    min-width: 100%;
    justify-content: flex-end;
  }

  .request-change {
    max-width: 520px;
    max-height: 520px;
    width: 100% !important;
    background: #ffffff !important;
    border-radius: 10px 10px 0px 0px;
    &.large {
      max-width: 90vw;
      max-height: 90vh;
    }
    .modal {
      display: block !important;
    }
    .drop-down {
      width: 100%;
    }
    &.modal-content,
    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    &__content,
    svg {
      max-width: 80%;
      margin: auto;
      text-align: center;
    }
    &__title {
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 36px;

      color: #000000;
    }
    &__describe {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      /* or 125% */

      text-align: center;

      color: #616e7c;
    }
  }
  .woven-color {
    &.height {
      width: 100% !important;
      max-width: 404px;
      height: 50px;
    }
  }
  .modal-backdrop.fade.in {
    display: none;
  }
}
</style>
